import { render } from "./ValidateEmail.vue?vue&type=template&id=286cd58a"
import script from "./ValidateEmail.vue?vue&type=script&lang=js"
export * from "./ValidateEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__